import * as angular from 'angular';

class AptModalHeaderWithSearchComponentCtrl {
  static bindings = {
    isSearchVisible: '<',
    headingTitle: '<',
    headingData: '<',
    closeModal: '&',
    searchTerm: '=',
    onSearchTermChange: '&',
    placeHolderText: '@'
  };

  isSearchVisible = true;

  constructor() {
    'ngInject';
  }
}

export const AptModalHeaderWithSearchComponent = {
  template: require('./aptModalHeaderWithSearch.component.html'),
  controller: AptModalHeaderWithSearchComponentCtrl,
  transclude: true,
  bindings: AptModalHeaderWithSearchComponentCtrl.bindings
};
